import React, { useState, useMemo } from "react";
import "./Close.css";

const sampleData = [
  { accountNo: "AC001", name: "Navin Kumar", guardian: "Ramesh Kumar", mobile: "9876543210", aadhar: "1234-5678-9012", status: "Saving", approvalDate: "2023-01-01", approvedBy:"Admin", ClosureDate: "02/01/2023", DepositAmount: "1000", bonus: "Yes", CloserAmount: "500", EarnedInterest: "Yes", Remarks: "Good", closedBy: "Admin", benefits: "Yes" },
  { accountNo: "AC003", name: "Pooja Singh", guardian: "Mohan Singh", mobile: "9998887776", aadhar: "5555-8888-4444", status: "RD", approvalDate: "2023-07-12", approvedBy:"Admin", ClosureDate: "15/08/2023", DepositAmount: "2000", bonus: "Yes", CloserAmount: "1000", EarnedInterest: "No", Remarks: "Good", closedBy: "Admin", benefits: "No" },
];

const accountTypes = ["Saving", "FD", "RD", "DD", "MIS"];

const CloserAccount = () => {
  const [entries, setEntries] = useState(5);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [modalData, setModalData] = useState([]); // Array for multiple accounts

  const [accountType, setAccountType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [filtered, setFiltered] = useState(false);

  // Filter + Search
  const filteredData = useMemo(() => {
    if (!filtered) return sampleData; // show all before submit
    return sampleData.filter((item) => {
      const matchSearch = 
        item.name.toLowerCase().includes(search.toLowerCase()) ||
        item.accountNo.toLowerCase().includes(search.toLowerCase()) ||
        item.mobile.includes(search) ||
        item.aadhar.includes(search);

      const matchAccountType = accountType ? item.status.toLowerCase() === accountType.toLowerCase() : true;
      const matchAccountNumber = accountNumber ? item.accountNo.toLowerCase().includes(accountNumber.toLowerCase()) : true;
      const matchFromDate = fromDate ? item.approvalDate >= fromDate : true;
      const matchToDate = toDate ? item.approvalDate <= toDate : true;

      return matchSearch && matchAccountType && matchAccountNumber && matchFromDate && matchToDate;
    });
  }, [search, accountType, accountNumber, fromDate, toDate, filtered]);

  const totalPages = Math.ceil(filteredData.length / entries);
  const startIndex = (currentPage - 1) * entries;
  const currentData = filteredData.slice(startIndex, startIndex + entries);

  // Add to modal array
  const handleView = (data) => {
    setModalData((prev) => {
      if (!prev.find((item) => item.accountNo === data.accountNo)) {
        return [...prev, data];
      }
      return prev;
    });
  };

  const closeModal = () => setModalData([]);

  const handleSubmitFilter = () => setFiltered(true);

  return (
    <div className="closerAccount-container">
      <div className="closerAccountreport-header">
        <h2>Banking Account Closure Filter</h2>
      </div>

      {/* Filter Section */}
      <div className="closerAccount-filter">
        <h3 className="closerAccountfilter-title">Filter Accounts</h3>
        <div className="closerAccountfilter-grid-2x2">
          <div className="closerAccountfilter-field">
            <label>Account Type</label>
            <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
              <option value="">All Types</option>
              {accountTypes.map((type, idx) => <option key={idx} value={type}>{type}</option>)}
            </select>
          </div>
          <div className="closerAccountfilter-field">
            <label>From Date</label>
            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          </div>
          <div className="closerAccountfilter-field">
            <label>To Date</label>
            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </div>
          <div className="closerAccountfilter-field">
            <label>Account No.</label>
            <input type="text" placeholder="Enter Account No." value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} />
          </div>
        </div>
        <button className="closerAccountbtnsubmit-btn" onClick={handleSubmitFilter}>Submit</button>
      </div>

      {/* Search + Entries */}
      <div className="closerAccount-topbar">
       <h2>Banking Account Closure Report</h2>
        <select value={entries} onChange={(e) => setEntries(Number(e.target.value))}>
          <option value={5}>5 Entries</option>
          <option value={10}>10 Entries</option>
          <option value={20}>20 Entries</option>
        </select>
      </div>

      {/* Grid Table */}
      <div className="closerAccount-table-container">
        <div className="closerAccount-grid-header">
          {["S.No","Account No","Name","Guardian","Mobile","Aadhar","Status","Approval Date","Action"].map((h,i) => (
            <div key={i} className="closerAccountgrid-header-item">{h}</div>
          ))}
        </div>
        {currentData.length > 0 ? currentData.map((item,index) => (
          <div key={index} className="closerAccount-grid-row">
            <div className="closerAccountgrid-item">{startIndex+index+1}</div>
            <div className="closerAccountgrid-item">{item.accountNo}</div>
            <div className="closerAccountgrid-item">{item.name}</div>
            <div className="closerAccountgrid-item">{item.guardian}</div>
            <div className="closerAccountgrid-item">{item.mobile}</div>
            <div className="closerAccountgrid-item">{item.aadhar}</div>
            <div className="closerAccountgrid-item">{item.status}</div>
            <div className="closerAccountgrid-item">{item.approvalDate}</div>
            <div className="closerAccountgrid-item">
              <button className="closerAccountbtnview-btn" onClick={() => handleView(item)}>View</button>
            </div>
          </div>
        )) : (
          <div className="closerAccountno-records">No records found</div>
        )}
      </div>

      {/* Pagination */}
      <div className="closerAccount-pagination">
        <span>Showing {filteredData.length ? startIndex+1 : 0} to {Math.min(startIndex+entries,filteredData.length)} of {filteredData.length} entries</span>
        <div className="closerAccountpagination-buttons">
          <button onClick={()=>setCurrentPage(p=>Math.max(p-1,1))} disabled={currentPage===1}>Previous</button>
          <button onClick={()=>setCurrentPage(p=>Math.min(p+1,totalPages))} disabled={currentPage===totalPages}>Next</button>
        </div>
      </div>

      {/* Modal */}
      
{modalData.length > 0 && (
  <div className="closerAccountmodal-overlay">
    <div className="closerAccountmodal-box">
      <h3 className="closerAccountmodal-title">Selected Accounts</h3>

      <div className="closerAccountmodal-cards-container">
        {modalData.map((data, idx) => (
          <div key={idx} className="closerAccountmodal-card">
            {/* Left Half */}
            <div className="closerAccountmodal-card-half">
              {Object.entries(data)
                .slice(0, Math.ceil(Object.entries(data).length / 2))
                .map(([key, value]) => (
                  <div key={key} className="closerAccountmodal-card-row">
                    <span className="closerAccountmodal-card-key">{key.replace(/([A-Z])/g," $1")}:</span>
                    <span className="closerAccountmodal-card-value">{value}</span>
                  </div>
                ))}
            </div>

            {/* Right Half */}
            <div className="closerAccountmodal-card-half">
              {Object.entries(data)
                .slice(Math.ceil(Object.entries(data).length / 2))
                .map(([key, value]) => (
                  <div key={key} className="closerAccountmodal-card-row">
                    <span className="closerAccountmodal-card-key">{key.replace(/([A-Z])/g," $1")}:</span>
                    <span className="closerAccountmodal-card-value">{value}</span>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>

      <div className="closerAccountmodal-actions">
        <button className="closerAccountbtnclose-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  </div>
)}

      
    </div>
  );
};

export default CloserAccount;
